import {
    FETCH_DEPARTMENTS_REQUEST,
    FETCH_DEPARTMENTS_SUCCESS,
    FETCH_DEPARTMENTS_FAILURE,
    CREATE_DEPARTMENT_REQUEST,
    CREATE_DEPARTMENT_SUCCESS,
    CREATE_DEPARTMENT_FAILURE,
    FETCH_DEPARTMENT_DETAILS_REQUEST,
    FETCH_DEPARTMENT_DETAILS_SUCCESS,
    FETCH_DEPARTMENT_DETAILS_FAILURE,
    CLEAR_DEPARTMENT_DETAILS,
  } from '../../types';
  
  export interface Department {
    Id: string;
    Name: string;
    Code: string;
    Head?: string;
    Status?: string;
    EmailAlias?: string;
    BudgetCurrency?: string;
    AnnualBudget?: number;
    Timezone?: string;
    CostCenter?: string;
    Description?: string;
    CreatedBy?: number;
    UpdatedBy?: number;
    CreatedAt?: string;
    UpdatedAt?: string;
  }
  
  export type DepartmentActionTypes =
    | { type: typeof FETCH_DEPARTMENTS_REQUEST }
    | { type: typeof FETCH_DEPARTMENTS_SUCCESS, payload: { departments: Department[]; total: number; currentPage: number; totalPages: number } }
    | { type: typeof FETCH_DEPARTMENTS_FAILURE, payload: string }
    | { type: typeof CREATE_DEPARTMENT_REQUEST }
    | { type: typeof CREATE_DEPARTMENT_SUCCESS }
    | { type: typeof CREATE_DEPARTMENT_FAILURE, payload: string }
    | { type: typeof FETCH_DEPARTMENT_DETAILS_REQUEST }
    | { type: typeof FETCH_DEPARTMENT_DETAILS_SUCCESS, payload: Department }
    | { type: typeof FETCH_DEPARTMENT_DETAILS_FAILURE, payload: string }
    | { type: typeof CLEAR_DEPARTMENT_DETAILS };
  
  
  interface DepartmentState {
    departments: Department[];
    department: Department | null;
    loading: boolean;
    error: string | null;
    total: number;
    currentPage: number;
    totalPages: number;
  }
  
  const initialState: DepartmentState = {
    departments: [],
    department: null,
    loading: false,
    error: null,
    total: 0,
    currentPage: 1,
    totalPages: 1,
  };
  
  export const departmentReducer = (
    state = initialState,
    action: DepartmentActionTypes
  ): DepartmentState => {
    switch (action.type) {
      case FETCH_DEPARTMENTS_REQUEST:
      case CREATE_DEPARTMENT_REQUEST:
      case FETCH_DEPARTMENT_DETAILS_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
  
      case FETCH_DEPARTMENTS_SUCCESS:
        return {
          ...state,
          loading: false,
          departments: action.payload.departments,
          total: action.payload.total,
          currentPage: action.payload.currentPage,
          totalPages: action.payload.totalPages,
        };
  
      case FETCH_DEPARTMENT_DETAILS_SUCCESS:
        return {
          ...state,
          loading: false,
          department: action.payload,
        };
  
      case CREATE_DEPARTMENT_SUCCESS:
        return {
          ...state,
          loading: false,
        };
  
      case FETCH_DEPARTMENTS_FAILURE:
      case CREATE_DEPARTMENT_FAILURE:
      case FETCH_DEPARTMENT_DETAILS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      case CLEAR_DEPARTMENT_DETAILS:
        return {
          ...state,
          department: null,
        };
  
      default:
        return state;
    }
  };
  